import { UserSelfAPIResponse } from '../users/api/user.model';

export enum InvitationState {
  NEW = 'NEW',
  SENT = 'SENT',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum InvitationSource {
  SERVICE_INVITATION = 'SERVICE_INVITATION',
  SELF_REGISTRATION = 'SELF_REGISTRATION',
}

export interface Invitation {
  requestId: string;
  userId: string;
  email: string;
  workspaceId: string;
  companyName: string;
  createdAt: number;
  updatedAt: number;
  sentAt: number;
  invitationTtlMinutes: number;
  requestSource: InvitationSource;
  requestedByUserId: string | null;
  personalMessage: string;
  status: InvitationState;
  reviewedByUserId: string | null;
  reviewedAt: string;
  companyGroupId: string;
  companyGroupName: string;
  user: Partial<UserSelfAPIResponse>;
  userActive?: boolean;
}

export interface GetInvitationsParams {
  state?: InvitationState;
  workspaceId: string;
}

export interface UpdateInvitationRequest {
  requestId: string;
  workspaceId: string;
  state: InvitationState;
  companyGroupId?: string;
  companyGroupName?: string;
  storeGroupId?: string;
  storeGroupName?: string;
}
